import { render, staticRenderFns } from "./TileDataGoralLogistics.vue?vue&type=template&id=1294cdea&scoped=true&"
import script from "./TileDataGoralLogistics.vue?vue&type=script&lang=js&"
export * from "./TileDataGoralLogistics.vue?vue&type=script&lang=js&"
import style0 from "./TileDataGoralLogistics.vue?vue&type=style&index=0&id=1294cdea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1294cdea",
  null
  
)

export default component.exports